import { getTelegramWebApp, isTMA, isTMADesktop } from '@web/libs/tg/platform'
import { safeTelegramCall } from '@web/libs/tg/safe-call'

export function installTmaFullscreen(): void {
  if (!isTMA()) return

  const webApp = getTelegramWebApp()

  if (!webApp) return

  safeTelegramCall(() => webApp.ready())
  safeTelegramCall(() => webApp.expand())

  if (isTMADesktop()) return

  // Старые клиенты и недоступный Android-мост не должны прерывать запуск.
  safeTelegramCall(() => webApp.requestFullscreen?.())
}
